export const extractSubdomain = () => {
  const path = window.location.pathname.split("/");
  const domainName = path.length > 1 ? path[1] : null;
  return domainName;
};
